var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVirtualLayer1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8278 4.57081L17.655 6.71445C19.0459 7.32808 19.0459 8.34263 17.655 8.95626L12.8278 11.0999C12.2796 11.3454 11.3796 11.3454 10.8314 11.0999L6.00412 8.95626C4.61321 8.34263 4.61321 7.32808 6.00412 6.71445L10.8314 4.57081C11.3796 4.32536 12.2796 4.32536 12.8278 4.57081Z",
    stroke: "#0068FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63672 11.1816C4.63672 11.8689 5.15217 12.6625 5.78217 12.9407L11.3376 15.4116C11.7631 15.5998 12.2458 15.5998 12.6631 15.4116L18.2185 12.9407C18.8485 12.6625 19.364 11.8689 19.364 11.1816",
    stroke: "#0068FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63672 15.2725C4.63672 16.0334 5.08672 16.7206 5.78217 17.0316L11.3376 19.5025C11.7631 19.6906 12.2458 19.6906 12.6631 19.5025L18.2185 17.0316C18.914 16.7206 19.364 16.0334 19.364 15.2725",
    stroke: "#0068FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualLayer1);
export default __webpack_public_path__ + "static/media/virtual-layer-1.f88906ff0807c61ef04c28c355caae01.svg";
export { ForwardRef as ReactComponent };